import React, { forwardRef } from 'react';

const ResponsiveVariposeImage = forwardRef(({ src, alt, className, style, ...props }, ref) => {
  // Convert the original PNG path to WebP cache path
  const getWebPImageSrc = (originalSrc) => {
    if (!originalSrc) return originalSrc;
    
    // Remove leading slash and get the path parts
    const relativePath = originalSrc.replace(/^\//, '');
    const pathParts = relativePath.split('/');
    
    // Expected format: img/varipose/filename.png
    // Convert to: img/cache/varipose/filename-large-1440w.webp
    if (pathParts.length >= 3 && pathParts[0] === 'img' && pathParts[1] === 'varipose') {
      const filename = pathParts[2];
      const nameWithoutExt = filename.replace(/\.(png|jpg|jpeg)$/i, '');
      // The optimization script adds an extra underscore, so we need to match that format
      const webpPath = `/img/cache/varipose/${nameWithoutExt}-large-1440w.webp`;
      return webpPath;
    }
    
    return originalSrc;
  };

  const webpSrc = getWebPImageSrc(src);

  const handleError = (e) => {
    // If WebP fails to load, fallback to original PNG
    if (e.target.src.includes('.webp')) {
      e.target.src = src;
    }
  };

  return (
    <img
      ref={ref}
      src={webpSrc}
      alt={alt}
      className={className}
      style={style}
      onError={handleError}
      {...props}
    />
  );
});

ResponsiveVariposeImage.displayName = 'ResponsiveVariposeImage';

export default ResponsiveVariposeImage;
